import script from "./orderRefund.vue?vue&type=script&setup=true&lang=js"
export * from "./orderRefund.vue?vue&type=script&setup=true&lang=js"

import "./orderRefund.vue?vue&type=style&index=0&id=6d74b599&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d74b599"]])

export default __exports__